<!-- 用水类型分析 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <Echart ref="option" :options="option" style="height: 100%;"></Echart>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts/lib/echarts';
  import {
    putAction
  } from '@/api/manage'
  export default {
    data() {
      return {
        title: this.$t('用水类型分析'),
        url: {
          doQueryMeterIndexTotalUser: "/jeecg-charge/meter/waterAnalysis/doQueryMeterIndexTotalUser"
        },
        option: {},
        intervalId: null,
        angle: 0,
        meterUserTotal: '',
        indexUserNumKindMessageList: []
      }
    },
    mounted() {},
    methods: {
      init() {
        this.$refs.option.showLoading('default',{
            maskColor: 'rgba(0,0,0,0.3)',
            color: '#6ED9F2',
            text: ''
        })
        this.resetData();
        this.getData();
      },
      resetData() {
          this.option = this.$options.data.call(this).option
          if(this.intervalId !== null){
              clearInterval(this.intervalId)
              this.intervalId = null;
          }
          this.angle = this.$options.data.call(this).angle
      },
      getData(){
        putAction(this.url.doQueryMeterIndexTotalUser,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.meterUserTotal = data.meterUserTotal;
            this.indexUserNumKindMessageList = data.indexUserNumKindMessageList;
            // this.setOption()
            setTimeout(()=> {
                this.intervalId = setInterval(()=>{
                    this.angle = this.angle + 5
                    this.setOption()
                },100)
            },1000)
          }
        })
      },
      setOption() {
        let angle = this.angle
        let data = this.indexUserNumKindMessageList
        let total = this.meterUserTotal;
        let seriesData = []
        for (let i = 0; i < data.length; i++) {
          seriesData.push({
            name: data[i].meterUserPriceName,
            value: data[i].meterUserNum,
          })
        }
        if(this.angle == 5){
          this.$refs.option.hideLoading()
        }
        this.option = {
          color: ['#FECA20', '#50E3C2', '#FA6400', '#0091FF', '#0394FF', '#4634FA', '#0C2D82', '#B620E0','#32C5FF', '#99CC33',  '#E02020','#3A7BD5','#7ffa34','#CC9933','#FF99CC','#666633','#006600','#990033','#CCCCFF'],
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            }
          },
          grid: {
            top: '20%',
            left: '3%',
            right: '2%',
            containLabel: true
          },
          title: {
            text: `{total|${total}}{unit|${this.$t('户')}}`,
            textStyle: {
              color: '#52C4DF',
              rich: {
                total: {
                  color: '#52C4DF',
                  fontWeight: 500,
                  fontSize: 30,
                  fontFamily: 'ds-digital-bold'
      
                },
                unit: {
                  color: '#2A6BAC',
                  fontSize: 12,
                }
              }
            },
            left: 'center',
            top: 'center',
            itemGap: 0,
            subtext: this.$t('用户总数'),
            subtextStyle: {
              color: '#fff',
              verticalAlign: 'middle',
              lineHeight: 12
            }
          },
          series: [
            {
              name: "ring5",
              type: 'custom',
              coordinateSystem: "none",
              renderItem: function(params, api) {
                return {
                  type: 'arc',
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.35,
                    startAngle: (0 + angle) * Math.PI / 180,
                    endAngle: (90 + angle) * Math.PI / 180
                  },
                  style: {
                    stroke: "#00A2F3",
                    opacity: 0.5,
                    fill: "transparent",
                    lineWidth: 2
                  },
                  silent: true
                };
              },
              data: [0]
            },
            {
              name: "ring5",
              type: 'custom',
              coordinateSystem: "none",
              renderItem: function(params, api) {
                return {
                  type: 'arc',
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.35,
                    startAngle: (120 + angle) * Math.PI / 180,
                    endAngle: (210 + angle) * Math.PI / 180
                  },
                  style: {
                    stroke: "#00A2F3",
                    opacity: 0.5,
                    fill: "transparent",
                    lineWidth: 2
                  },
                  silent: true
                };
              },
              data: [0]
            },
            {
              name: "ring5",
              type: 'custom',
              coordinateSystem: "none",
              renderItem: function(params, api) {
                return {
                  type: 'arc',
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.35,
                    startAngle: (240 + angle) * Math.PI / 180,
                    endAngle: (330 + angle) * Math.PI / 180
                  },
                  style: {
                    stroke: "#00A2F3",
                    fill: "transparent",
                    opacity: 0.5,
                    lineWidth: 2
                  },
                  silent: true
                };
              },
              data: [0]
            },
            {
              name: '',
              type: 'pie',
              radius: ['45%', '55%'],
              // center: ['50%', '50%'],
              animationDelay: 100,
              animationDuration: 2000,
              label: {
                show: true,
                // fontSize: '12px',
                // minMargin: 50,
                // edgeDistance: 20,
                // lineHeight: 50,
                // alignTo: 'edge',
                // position: 'outer',
                // width: 0,
                // height: 30,
                // lineHeight: 0,
                // padding: [5, -2, 5, -2],
                // borderRadius: 2,
                // distanceToLabelLine: 0,
                // formatter: function(params) {
                //   let percent = 0
                //   if (total == 0) {
                //     percent = 100
                //   }
                //   let index = params.dataIndex
                //   percent = ((params.value / total) * 100).toFixed(0);
                //   return [
                //     `{topnumber${index}|${params.value}}{top${index}|个}{topnumber${index}|${percent}}{top${index}|%}\n{bottom${index}|${params.name}}`,
                //     `{hr${index}|}`
                //   ].join('\n')
                // },
                // align: 'center',
                // rich: {}
                // this.setRichText(color)
              },
              labelLine: {
                // lineStyle: {
                // 	type: [5]
                // },
                // normal: {
                //   smooth: 0.2,
                  // length: 2,
                  // length2: 1,
                // }
              },
              minAngle: 7,
              data: seriesData
            }
          ]
        };
        window.addEventListener('resize', function () {
          this.$refs.option.resize();
        })
      },
      // setRichText(colorList) {
      //   let richList = {}
      //   for (let i = 0; i < colorList.length; i++) {
      //     richList[`top${i}`] = {
      //       color: colorList[i],
      //       verticalAlign: 'bottom',
      //       padding: [5, 0, 0, 0],
      //       align: 'center'
      //     }
      //     richList[`topnumber${i}`] = {
      //       color: colorList[i],
      //       fontFamily: 'ds-digital-bold',
      //       verticalAlign: 'bottom',
      //       padding: [5, 0, 0, 0],
      //       fontSize: 20,
      //       align: 'center'
      //     }
      //     richList[`bottom${i}`] = {
      //       color: colorList[i],
      //       verticalAlign: 'top',
      //       padding: [0, 0, 5, 0],
      //       align: 'center'
      //     }
      //     richList[`hr${i}`] = {
      //       backgroundColor: colorList[i],
      //       borderRadius: 3,
      //       width: 3,
      //       height: 3,
      //       align: 'center',
      //       padding: [3, 3, 0, -12]
      //     }
      //   }
      //   return richList
      // },
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}

  .ant-radio-button-wrapper {
    color: #fff;
    background: transparent;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #1890FF;
  }
</style>